import React from 'react';

const NotificationToast = ({ notification }) => {
  if (!notification) return null;

  return (
    <div
      className={`notification notification-${notification.type}`}
      role={notification.type === 'error' ? 'alert' : 'status'}
      aria-live={notification.type === 'error' ? 'assertive' : 'polite'}
    >
      {notification.message}
    </div>
  );
};

export default NotificationToast;